module.exports = __webpack_public_path__ + "img/ring_y_e_1_0.f8f15ff2.png";